function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "808",
  height: "676",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("title", null, "Pseudo UI new"), /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(103 190)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pseudo UI new"
}, /*#__PURE__*/React.createElement("g", {
  id: "Background"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_fill",
  transform: "translate(-99 -68)",
  fill: "#BFBFBF",
  id: "Rectangle 30"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path1_fill",
  transform: "translate(-77 282)",
  fill: "#D2D3D4",
  id: "Rectangle 32"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path2_fill",
  transform: "translate(311 282)",
  fill: "#D2D3D4",
  id: "Rectangle 32"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path3_fill",
  transform: "translate(-77 -46)",
  fill: "#787A7D",
  id: "Rectangle 31"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_fill",
  transform: "translate(-99 -67)",
  fill: "url(#paint4_linear)",
  id: "Rectangle 30"
})), /*#__PURE__*/React.createElement("g", {
  id: "Account Settings Dialog"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle 30",
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path4_fill",
  transform: "translate(-29 -68)",
  fill: "#DDDEDF"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(301 36)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path6_fill",
  transform: "translate(5 124)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(47 196)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path7_fill",
  transform: "translate(47 240)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(393 196)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path5_fill",
  transform: "translate(393 240)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle 28",
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path8_fill",
  transform: "translate(261 298)",
  fill: "#CACCCE"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle 28",
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path9_fill",
  transform: "translate(439 298)",
  fill: "#0072CF"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path10_fill",
  transform: "translate(499 308)",
  fill: "#FFF",
  id: "OK"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path11_fill",
  transform: "translate(47 28)",
  id: "Keep me logged in"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path12_fill",
  transform: "translate(300 309)",
  fill: "#414042",
  id: "Cancel"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path13_fill",
  transform: "translate(3 -31)",
  id: "Account Settings"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path14_fill",
  fill: "url(#pattern0)",
  transform: "translate(3 31)",
  id: "Image 8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Toolbar",
  filter: "url(#filter3_d)"
}, /*#__PURE__*/React.createElement("g", {
  id: "glyphs"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path15_fill",
  transform: "translate(-99 -188)",
  fill: "#DCDDDF",
  id: "Rectangle 29"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern1)",
  transform: "translate(257 -160)",
  id: "sc_cog@2x"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern2)",
  transform: "translate(630 -160)",
  id: "Image 2",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern3)",
  transform: "translate(165 -160)",
  id: "Image 3",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern4)",
  transform: "translate(-77 -161)",
  id: "Image 4",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern5)",
  transform: "translate(5 -158)",
  id: "Image 5",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path16_fill",
  fill: "url(#pattern6)",
  transform: "translate(83 -160)",
  id: "Image 6",
  opacity: ".3"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path17_fill",
  transform: "translate(244 -106)",
  id: "Settings"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path18_fill",
  transform: "translate(165 -100)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path18_fill",
  transform: "translate(83 -100)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path18_fill",
  transform: "translate(5 -100)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path18_fill",
  transform: "translate(-77 -100)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path18_fill",
  transform: "translate(630 -100)",
  fill: "#BBBCBE",
  id: "Rectangle 28"
})))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_fill",
  d: "M0 0h800v553H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1_fill",
  d: "M0 0h368v204H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2_fill",
  d: "M0 0h368v136H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3_fill",
  d: "M0 0h756v308H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path4_fill",
  d: "M0 0h659v454H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path5_fill",
  d: "M0 1a1 1 0 011-1h182a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path6_fill",
  d: "M0 1a1 1 0 011-1h254a1 1 0 011 1v30a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path7_fill",
  d: "M0 1a1 1 0 011-1h302a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path8_fill",
  d: "M0 8a8 8 0 018-8h148a8 8 0 018 8v40a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path9_fill",
  d: "M0 8a8 8 0 018-8h144a8 8 0 018 8v40a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path10_fill",
  d: "M11.08 26.34c5.52 0 9.27-4.15 9.27-9.66 0-5.52-3.75-9.66-9.27-9.66-5.54 0-9.27 4.14-9.27 9.66 0 5.51 3.73 9.66 9.27 9.66zm0-2.08c-4.2 0-6.86-3.24-6.86-7.58 0-4.37 2.66-7.6 6.86-7.6 4.17 0 6.86 3.23 6.86 7.6 0 4.34-2.69 7.58-6.86 7.58zM38.15 26l-8.46-9.8 7.79-8.88h-2.92l-8.26 9.66V7.32h-2.32V26h2.32v-6.27l1.88-2.13 7.08 8.4h2.89z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path11_fill",
  d: "M16.35 26L7.9 16.2l7.78-8.88h-2.91L4.5 16.98V7.32H2.18V26h2.33v-6.27l1.87-2.13 7.09 8.4h2.88zm7.71.34c2.22 0 4.04-.73 5.38-2.08l-1-1.37a5.91 5.91 0 01-4.18 1.71c-2.91 0-4.7-2.13-4.87-4.68h10.95v-.53c0-4.06-2.41-7.25-6.5-7.25-3.86 0-6.66 3.16-6.66 7.08 0 4.23 2.88 7.12 6.88 7.12zm4.2-7.96H19.4c.1-2.07 1.54-4.5 4.42-4.5 3.08 0 4.43 2.49 4.45 4.5zm11.58 7.96c2.21 0 4.03-.73 5.38-2.08L44.2 22.9a5.91 5.91 0 01-4.17 1.71c-2.92 0-4.7-2.13-4.88-4.68h10.95v-.53c0-4.06-2.4-7.25-6.5-7.25-3.86 0-6.66 3.16-6.66 7.08 0 4.23 2.89 7.12 6.9 7.12zm4.2-7.96h-8.88c.12-2.07 1.54-4.5 4.43-4.5 3.08 0 4.42 2.49 4.45 4.5zm12.14 7.96c3.55 0 6.02-2.75 6.02-7.12 0-4.4-2.47-7.08-6.02-7.08-1.9 0-3.59.98-4.57 2.35v-2.01h-2.1v18.67h2.1v-7.2a5.54 5.54 0 004.57 2.39zm-.53-1.88c-1.66 0-3.3-1-4.04-2.18v-6.1a5 5 0 014.04-2.16c2.71 0 4.34 2.2 4.34 5.2s-1.63 5.24-4.34 5.24zM91.18 26v-9.77c0-2.72-1.32-4.09-3.78-4.09a5.7 5.7 0 00-4.54 2.52c-.39-1.4-1.56-2.52-3.64-2.52a5.85 5.85 0 00-4.36 2.3v-1.96h-2.1V26h2.1v-9.88c.72-1.1 2.18-2.1 3.55-2.1 1.77 0 2.5 1.09 2.5 2.8V26H83v-9.91a4.73 4.73 0 013.58-2.07c1.73 0 2.49 1.09 2.49 2.8V26h2.1zm10.3.34c2.2 0 4.03-.73 5.37-2.08l-1-1.37a5.91 5.91 0 01-4.18 1.71c-2.91 0-4.7-2.13-4.87-4.68h10.95v-.53c0-4.06-2.41-7.25-6.5-7.25-3.86 0-6.66 3.16-6.66 7.08 0 4.23 2.88 7.12 6.88 7.12zm4.2-7.96H96.8c.1-2.07 1.54-4.5 4.42-4.5 3.08 0 4.43 2.49 4.45 4.5zM120.46 26V7.32h-2.1V26h2.1zm10.1.34c4.1 0 6.69-3.2 6.69-7.12s-2.58-7.08-6.7-7.08c-4.11 0-6.69 3.16-6.69 7.08s2.58 7.12 6.7 7.12zm0-1.88c-2.9 0-4.51-2.46-4.51-5.24 0-2.74 1.62-5.2 4.5-5.2 2.89 0 4.48 2.46 4.48 5.2 0 2.78-1.6 5.24-4.48 5.24zm15.54 7.03c3.3 0 6.44-1.4 6.44-5.88V12.48h-2.1v2.04a5.6 5.6 0 00-4.54-2.38c-3.55 0-6.02 2.69-6.02 7.03 0 4.37 2.5 7 6.02 7 1.9 0 3.56-1.04 4.54-2.41v1.93c0 2.97-2.1 4.06-4.34 4.06-1.93 0-3.28-.5-4.4-1.85l-1.06 1.57c1.6 1.57 3.16 2.02 5.46 2.02zm.3-7.17c-2.7 0-4.33-2.18-4.33-5.15 0-3 1.62-5.15 4.34-5.15 1.68 0 3.3 1 4.03 2.18v5.9a5 5 0 01-4.03 2.22zm15.78 7.17c3.3 0 6.44-1.4 6.44-5.88V12.48h-2.1v2.04a5.6 5.6 0 00-4.54-2.38c-3.55 0-6.02 2.69-6.02 7.03 0 4.37 2.5 7 6.02 7 1.9 0 3.56-1.04 4.54-2.41v1.93c0 2.97-2.1 4.06-4.34 4.06-1.93 0-3.28-.5-4.4-1.85l-1.06 1.57c1.6 1.57 3.16 2.02 5.46 2.02zm.3-7.17c-2.71 0-4.33-2.18-4.33-5.15 0-3 1.62-5.15 4.34-5.15 1.68 0 3.3 1 4.03 2.18v5.9a5 5 0 01-4.03 2.22zm16.45 2.02c2.21 0 4.03-.73 5.37-2.08l-1-1.37a5.91 5.91 0 01-4.18 1.71c-2.9 0-4.7-2.13-4.87-4.68h10.95v-.53c0-4.06-2.4-7.25-6.5-7.25-3.86 0-6.66 3.16-6.66 7.08 0 4.23 2.88 7.12 6.89 7.12zm4.2-7.96h-8.88c.11-2.07 1.54-4.5 4.43-4.5 3.08 0 4.42 2.49 4.45 4.5zM200.5 26V7.32h-2.1v7.2a5.65 5.65 0 00-4.56-2.38c-3.56 0-6.02 2.8-6.02 7.11 0 4.4 2.49 7.09 6.02 7.09a5.7 5.7 0 004.56-2.36V26h2.1zm-6.16-1.54c-2.71 0-4.34-2.21-4.34-5.2 0-3 1.63-5.24 4.34-5.24 1.68 0 3.3 1 4.06 2.18v6.13a5.03 5.03 0 01-4.06 2.13zm18.62-13.92c.79 0 1.43-.61 1.43-1.4 0-.78-.64-1.42-1.43-1.42-.75 0-1.4.64-1.4 1.42 0 .79.65 1.4 1.4 1.4zM214.04 26V12.48h-2.1V26h2.1zm15.41 0v-9.5c0-2.93-1.48-4.36-4.3-4.36a6.7 6.7 0 00-4.83 2.3v-1.96h-2.1V26h2.1v-9.88a5.22 5.22 0 014-2.1c1.83 0 3.03.75 3.03 3.13V26h2.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path12_fill",
  d: "M11.51 26.34c3.3 0 5.55-1.57 7.11-3.7l-1.98-1.1a6.23 6.23 0 01-5.13 2.72c-4.09 0-7.2-3.16-7.2-7.58 0-4.46 3.11-7.6 7.2-7.6a6.3 6.3 0 015.13 2.72l1.96-1.09a8.35 8.35 0 00-7.09-3.7 9.34 9.34 0 00-9.6 9.67 9.34 9.34 0 009.6 9.66zM32.06 26v-9.3c0-3.27-2.38-4.56-5.24-4.56-2.21 0-3.95.73-5.4 2.24l.98 1.46a5.37 5.37 0 014.14-1.88c1.96 0 3.42 1.04 3.42 2.86v2.43a5.65 5.65 0 00-4.48-1.85c-2.3 0-4.73 1.43-4.73 4.46 0 2.94 2.43 4.48 4.73 4.48 1.82 0 3.36-.65 4.48-1.88V26h2.1zm-5.83-1.18c-1.96 0-3.33-1.23-3.33-2.94 0-1.73 1.37-2.96 3.33-2.96 1.49 0 2.92.56 3.73 1.68v2.54a4.53 4.53 0 01-3.73 1.68zM47.5 26v-9.5c0-2.93-1.49-4.36-4.32-4.36a6.7 6.7 0 00-4.81 2.3v-1.96h-2.1V26h2.1v-9.88a5.22 5.22 0 014-2.1c1.82 0 3.03.75 3.03 3.13V26h2.1zm10.15.34c2.47 0 3.92-1.01 4.96-2.36l-1.4-1.28a4.08 4.08 0 01-3.44 1.76c-2.89 0-4.68-2.24-4.68-5.24s1.8-5.2 4.68-5.2c1.4 0 2.54.53 3.44 1.76l1.4-1.29a5.79 5.79 0 00-4.96-2.35c-4.03 0-6.74 3.08-6.74 7.08 0 4.04 2.71 7.12 6.74 7.12zm14 0c2.22 0 4.04-.73 5.38-2.08l-1-1.37a5.91 5.91 0 01-4.18 1.71c-2.9 0-4.7-2.13-4.87-4.68h10.95v-.53c0-4.06-2.4-7.25-6.5-7.25-3.86 0-6.66 3.16-6.66 7.08 0 4.23 2.88 7.12 6.89 7.12zm4.2-7.96h-8.87c.11-2.07 1.54-4.5 4.43-4.5 3.08 0 4.42 2.49 4.45 4.5zM83.44 26V7.32h-2.1V26h2.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path13_fill",
  d: "M20.77 29L12.16 7.66h-3.3L.3 29h3.04l1.89-4.74h10.62L17.73 29h3.04zm-5.73-7.1H5.98l4.55-11.5 4.51 11.5zm15.24 7.48a6.62 6.62 0 005.66-2.68l-1.6-1.48a4.66 4.66 0 01-3.93 2.02c-3.3 0-5.35-2.56-5.35-5.98 0-3.43 2.05-5.96 5.35-5.96 1.6 0 2.9.61 3.93 2.02l1.6-1.47a6.62 6.62 0 00-5.66-2.69c-4.61 0-7.71 3.52-7.71 8.1 0 4.6 3.1 8.12 7.7 8.12zm15.84 0a6.62 6.62 0 005.67-2.68l-1.6-1.48a4.66 4.66 0 01-3.94 2.02c-3.3 0-5.34-2.56-5.34-5.98 0-3.43 2.04-5.96 5.34-5.96 1.6 0 2.91.61 3.94 2.02l1.6-1.47a6.62 6.62 0 00-5.67-2.69c-4.6 0-7.71 3.52-7.71 8.1 0 4.6 3.1 8.12 7.71 8.12zm15.78 0c4.7 0 7.65-3.64 7.65-8.12 0-4.48-2.94-8.1-7.65-8.1-4.7 0-7.65 3.62-7.65 8.1 0 4.48 2.95 8.12 7.65 8.12zm0-2.14c-3.3 0-5.15-2.82-5.15-5.98 0-3.14 1.86-5.96 5.15-5.96 3.3 0 5.12 2.82 5.12 5.96 0 3.16-1.82 5.98-5.12 5.98zM86.3 29V13.54h-2.4V24.9a5.91 5.91 0 01-4.58 2.34c-2.08 0-3.46-.8-3.46-3.52V13.54h-2.4v10.92c0 3.36 1.7 4.92 4.93 4.92 2.3 0 4.32-1.21 5.5-2.56V29h2.4zm17.62 0V18.15c0-3.36-1.7-4.99-4.93-4.99a7.67 7.67 0 00-5.5 2.62v-2.24h-2.4V29h2.4V17.7a5.97 5.97 0 014.57-2.4c2.08 0 3.46.87 3.46 3.59V29h2.4zm8.7.38c1.4 0 2.27-.41 2.88-.99l-.7-1.79c-.33.35-.97.64-1.64.64-1.05 0-1.57-.83-1.57-1.98v-9.6h3.14v-2.12h-3.14V9.32h-2.4v4.22h-2.56v2.12h2.56v10.1c0 2.31 1.15 3.62 3.43 3.62zm20.76 0c5.76 0 7.87-3.16 7.87-6.27 0-4.48-3.97-5.57-7.46-6.5-2.72-.73-5.18-1.37-5.18-3.51 0-2.02 1.82-3.4 4.38-3.4 2.34 0 4.58.8 6.18 2.56l1.6-1.95c-1.8-1.89-4.32-2.97-7.59-2.97-4.19 0-7.32 2.4-7.32 5.92 0 4.19 3.8 5.15 7.23 6.04 2.81.77 5.4 1.48 5.4 4.04 0 1.63-1.2 3.68-5.02 3.68-3 0-5.3-1.48-6.72-3.04l-1.56 2.01c1.75 1.99 4.47 3.4 8.19 3.4zm18.72 0a8.4 8.4 0 006.14-2.36l-1.15-1.57a6.76 6.76 0 01-4.77 1.95c-3.33 0-5.38-2.43-5.57-5.34h12.51v-.61c0-4.64-2.75-8.29-7.42-8.29-4.42 0-7.62 3.62-7.62 8.1 0 4.83 3.3 8.12 7.88 8.12zm4.8-9.08h-10.15c.13-2.37 1.76-5.16 5.06-5.16 3.52 0 5.05 2.85 5.09 5.16zm10.15 9.08c1.41 0 2.28-.41 2.88-.99l-.7-1.79c-.32.35-.96.64-1.63.64-1.06 0-1.57-.83-1.57-1.98v-9.6h3.14v-2.12h-3.14V9.32h-2.4v4.22h-2.56v2.12h2.56v10.1c0 2.31 1.15 3.62 3.42 3.62zm9.41 0c1.4 0 2.27-.41 2.88-.99l-.7-1.79c-.32.35-.96.64-1.64.64-1.05 0-1.56-.83-1.56-1.98v-9.6h3.13v-2.12h-3.13V9.32h-2.4v4.22h-2.56v2.12h2.56v10.1c0 2.31 1.15 3.62 3.42 3.62zm6.69-18.04a1.61 1.61 0 10-1.6-1.6c0 .9.73 1.6 1.6 1.6zM184.36 29V13.54h-2.4V29h2.4zm17.62 0V18.15c0-3.36-1.7-4.99-4.93-4.99a7.67 7.67 0 00-5.5 2.62v-2.24h-2.4V29h2.4V17.7a5.97 5.97 0 014.58-2.4c2.08 0 3.45.87 3.45 3.59V29h2.4zm11 6.27c3.78 0 7.36-1.6 7.36-6.72v-15h-2.4v2.33a6.4 6.4 0 00-5.18-2.72c-4.06 0-6.88 3.07-6.88 8.03 0 5 2.85 8 6.88 8a6.46 6.46 0 005.18-2.75v2.2c0 3.4-2.4 4.65-4.96 4.65-2.2 0-3.74-.58-5.02-2.11l-1.22 1.79c1.83 1.79 3.62 2.3 6.24 2.3zm.36-8.19c-3.1 0-4.97-2.5-4.97-5.89 0-3.42 1.86-5.89 4.97-5.89a5.7 5.7 0 014.6 2.5v6.75a5.72 5.72 0 01-4.6 2.53zm16.7 2.3c4 0 6.09-2.08 6.09-4.67 0-3.42-3.1-4.19-5.8-4.8-2.01-.48-3.77-.9-3.77-2.37 0-1.37 1.31-2.43 3.42-2.43 1.99 0 3.68.83 4.61 1.95l1.12-1.66a7.82 7.82 0 00-5.73-2.24c-3.68 0-5.76 2.05-5.76 4.45 0 3.2 2.98 3.9 5.6 4.51 2.08.51 3.97.96 3.97 2.66 0 1.53-1.28 2.65-3.65 2.65a7 7 0 01-5.09-2.2l-1.24 1.72c1.56 1.67 3.7 2.43 6.24 2.43z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path14_fill",
  d: "M0 0h28v28H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path15_fill",
  d: "M0 8a8 8 0 018-8h784a8 8 0 018 8v112H0V8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16_fill",
  d: "M0 0h48v48H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path17_fill",
  d: "M6.36 18.24c3.6 0 4.92-1.98 4.92-3.92 0-2.8-2.48-3.48-4.66-4.06-1.7-.46-3.24-.86-3.24-2.2 0-1.26 1.14-2.12 2.74-2.12 1.46 0 2.86.5 3.86 1.6l1-1.22a6.27 6.27 0 00-4.74-1.86c-2.62 0-4.58 1.5-4.58 3.7 0 2.62 2.38 3.22 4.52 3.78 1.76.48 3.38.92 3.38 2.52 0 1.02-.76 2.3-3.14 2.3a5.64 5.64 0 01-4.2-1.9l-.98 1.26a6.6 6.6 0 005.12 2.12zm11.7 0c1.58 0 2.88-.52 3.84-1.48l-.72-.98A4.22 4.22 0 0118.2 17c-2.08 0-3.36-1.52-3.48-3.34h7.82v-.38c0-2.9-1.72-5.18-4.64-5.18-2.76 0-4.76 2.26-4.76 5.06 0 3.02 2.06 5.08 4.92 5.08zm3-5.68h-6.34c.08-1.48 1.1-3.22 3.16-3.22 2.2 0 3.16 1.78 3.18 3.22zm6.35 5.68c.88 0 1.42-.26 1.8-.62l-.44-1.12c-.2.22-.6.4-1.02.4-.66 0-.98-.52-.98-1.24v-6h1.96V8.34h-1.96V5.7h-1.5v2.64h-1.6v1.32h1.6v6.32c0 1.44.72 2.26 2.14 2.26zm5.88 0c.88 0 1.42-.26 1.8-.62l-.44-1.12c-.2.22-.6.4-1.02.4-.66 0-.98-.52-.98-1.24v-6h1.96V8.34h-1.96V5.7h-1.5v2.64h-1.6v1.32h1.6v6.32c0 1.44.72 2.26 2.14 2.26zm4.18-11.28a1 1 0 001.02-1c0-.56-.46-1.02-1.02-1.02-.54 0-1 .46-1 1.02a1 1 0 001 1zM38.23 18V8.34h-1.5V18h1.5zm11.01 0v-6.78c0-2.1-1.06-3.12-3.08-3.12a4.8 4.8 0 00-3.44 1.64v-1.4h-1.5V18h1.5v-7.06a3.73 3.73 0 012.86-1.5c1.3 0 2.16.54 2.16 2.24V18h1.5zm6.88 3.92c2.36 0 4.6-1 4.6-4.2V8.34h-1.5V9.8a4 4 0 00-3.24-1.7c-2.54 0-4.3 1.92-4.3 5.02 0 3.12 1.78 5 4.3 5 1.36 0 2.54-.74 3.24-1.72v1.38c0 2.12-1.5 2.9-3.1 2.9-1.38 0-2.34-.36-3.14-1.32l-.76 1.12c1.14 1.12 2.26 1.44 3.9 1.44zm.22-5.12c-1.94 0-3.1-1.56-3.1-3.68 0-2.14 1.16-3.68 3.1-3.68 1.2 0 2.36.72 2.88 1.56v4.22a3.58 3.58 0 01-2.88 1.58zm10.44 1.44c2.5 0 3.8-1.3 3.8-2.92 0-2.14-1.94-2.62-3.62-3-1.26-.3-2.36-.56-2.36-1.48 0-.86.82-1.52 2.14-1.52 1.24 0 2.3.52 2.88 1.22l.7-1.04a4.89 4.89 0 00-3.58-1.4c-2.3 0-3.6 1.28-3.6 2.78 0 2 1.86 2.44 3.5 2.82 1.3.32 2.48.6 2.48 1.66 0 .96-.8 1.66-2.28 1.66a4.38 4.38 0 01-3.18-1.38l-.78 1.08a5.14 5.14 0 003.9 1.52z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path18_fill",
  d: "M0 1a1 1 0 011-1h46a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"
}), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0",
  transform: "scale(.03571)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern1",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image1",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern2",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image2",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern3",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image3",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern4",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image4",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern5",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image5",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "pattern6",
  patternUnits: "objectBoundingBox",
  patternContentUnits: "objectBoundingBox",
  width: "1",
  height: "1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image6",
  transform: "scale(.02083)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: "28",
  height: "28",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAEBUlEQVRIDa1W32sURxz/7O7M7s7u5QxaL0o1FksNtqaNRSUUJA0UUgo+iKU+Bh+k+tKXtoLQ0qc+tA9SqND+BYW2lPhQUUFMCH1rwUhqgxY0ajTN5WIv98Pc7c/ynb3dnPHuNFsXZndmZ+b7mc/n+52ZrzI3dz8EgHxVwcQ9HdfyOmZLHBVPhUIdKR4ymGEBXsq6GOhxMdzrImeHgKJAIcDriww/3xSYXjKga4CqRCUFVjIlCAEqjg/0v+Dgg74a9uR8MGJGYDMPDQiO1KwSpEYlXrSmAjNLOn66AeSsKlSSkZhx9vzAmsHJLWR7uqBj/C4Hm8rrUsa0/oqNh6EMhbgpv4oSWaU3uWpqQQe7U+JQ1cfGrbtBYEEQyEKTCUjTNND/GJQkni0xqBSN1Ej7kFEqDB5ODak4f0zgyGvRApptEsb/xZJABOZ5Ht7rAw69KpA1VYzuE/B9vxlP1olXajEJiB6S8sWsj+ODdgJwcaaCMAiSdnMlNSAZkXIGPk4c0CUz+je7VMd3k8vNGI/VUwFKoIaU77wcYniXSIx+dXERxTqD0iYSUwGSdZJyo+nj5FurUp6bKmLylg9LCDDGkghNVgOANTfieuyfuL32K/tDHx8O6sh1abL7QdHFN+NFCMsG13Woz8owlouizFBchIEn2cSLoC/1DW4LMNJnJms5czmPhzUOwzTbgtHglpKSXMf3A2OjNr5+l6OLR6Dx5raZi48OWmBatIEvTS/jwowH27allO3YdQQ8OiAguIIDO3R8fJBLpsSMyrF9DNu6uWSXL3s4M1GEKYSUkk6YTk9LhrSHfvi9lMwbfsXE6JsqfM/D3i0+jryxGijfXlnEfIVJwE7MYmMtg4Y6z06WsdUGRvo3yLGj+23MLy/jcL8Aa5yFv/1dxrnpOuyuDU+VsiOgxhgCheOzXwvY2s3x+nYLXFPw+Uh3PA/lmo8vLxWgmzZ0w+gYKMmkVkFDpztJI4SAo1r4ZGwBc//Wm+fI+tnxRdwvcZiNqIxvhScGrvnR0ocEyDiHbVn4p8Lx6S/zeOSsno1/zFbx49U6LIpKTtdbSzNroKKm+uS1GXVQtNEGJqN/Lmg4PTaPQsXDXw9W8MX5AlRudtzgrdAISxn6fiWkG7jdnUhXT71Ww6NqFY7jyOPKEAKZTAZ8HewooUIQgO3IurhdNtoC0pkYGoZcMDEmXxmG8cxRGTMlwJ1ZD2xgs4MbRQOUXbW7+AmU/ETRGAfVevxG5Chd3NvjQh3qddC/qQ7XA9r5k0CkTzlfNzOySbYpN32714FKGfH7u1awe2MdKy7gBVECG0uR9ksSki2yuXtTlAjnMo3rac9mDzmrgol7TpLql55Dqk8+G+hxolQ/Ey39P+fjjvTlC9krAAAAAElFTkSuQmCC"
}), /*#__PURE__*/React.createElement("image", {
  id: "image1",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACdElEQVR4Ae1aa3HDMAwWhDHYIJTBZKfDkTJYGTQMOgaBUAiBUAiBUAiblcfOTWtHsp3Eu9t3px9bU1ufrJeVAiQGIr4p1N/PhD6D3GGUPLgJ6APkDqNk7SFQQ+5QqFoXASMt5Ayf/28WBxr1iSzH2djn/5I4QNyjwqIxe1cQg0H5383N37WLCP3ffH6ZI0DPeNZ4MQTPk+crSKG87cdmk6O16YGsNaf4oxSNfRrDfjcH6Qok8Ch/R2QmYLnCWkdEAlE1CRRLLfwMppR6z42AOHtNg2lL0SEFkDKCcgTV2q4TXDvMF09bE7AzXhASZZpg60MspAQogyEWpdb6dVzDnOTOSImMQpeUAKc1mPgqMtZ8kxglqgXnV1h1paDnrtsnCHXlrV00EAJOZ2lZnq38hATrJERZiB6mY+P6a0x7zC2YfQNIOj3Zy1K4Vl1fwg8yjcUFIhHQtrR9VzwQEn55Yv2ihEjQGjE6RBL42EEkKN1uRgAS4Z9AuAvFX9CpSm9IIH5QJaz2jwT6NNr1KbW8cQuskhZ0QH+EXRq977dsi3SENLuQ7RECwa32fSFzKOy0DD+95dVK3G/CrZLLNXOkA4SCXEnmm5zpHU3dJO10ZLWXBrbVeO0sQ3T9VsAAbP0bWWKJvpEdN1R+PNEKQiC9+i0ot5As533Tsr6oL6Hy7OvkaiIqmJm4zkQEbQtzIteuOV43OlUggYcEBdXJeq4MGcePAzBrnU8XEbHyLhImpZ1dGWEoVqxXTK6mbFijTqK8TaK3FmfqNn9B57QGYwqPVl4KTgeb4ha3KJR/tpT3i26CrwDqv/BTA18cpBiELQ5fHCzh/z8hIx7tAXTCaQAAAABJRU5ErkJggg=="
}), /*#__PURE__*/React.createElement("image", {
  id: "image2",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,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"
}), /*#__PURE__*/React.createElement("image", {
  id: "image3",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC2ElEQVRoBe1YwW7TQBB9s/UHRErCufxB+IPF4gPIF9B+Qckn8AXlxrE5calQywUkkthLpSqnSJV641QJCU6VIlUC0dIdNARHqbuO7dgBR3gv9o5nZue9nd1ZL1C3moGagZqBmoH/mQFygfe1f8Dgbde3VWUEmlrYF8aYs1V9uOy8uFDrJ5phdwAntrh65j4DUFCi381slEHxHoBFGwJ6FqowYwTeB7jD4Mai/zLelwIITPCyjEF87b9loFOGr7iP33MaF25Sf57oWuttwNtWsB0G9gUEg7oATYsCilIIoDMG9dL8GTM0aTrRd9JadwgqBFB6fkaDrPJkYNeYoJ9mq6oYvARNwMEsK5ZDkDVQKebvhuul1qKNX8TubZTwCuDC+/8im2TpMxPe3ZEBfQvbA7wOwco6zN2cM0CMb7k9OQyY6RrApNVq9YOPwfu4igRvjJnKrkPAcfx7lr57BrJYLtGRwIn4vN1unh8eHgqIhOZJcTNa60beQhct8HUAmKQHPsNDsEe+9o8Z0ABSF6xYybavoPYY2AEwLQ0A89anm5vvk9PT06sEul1iYV4CSW1a+zsEfgaQloPhn9YoA8Cl53njwWDwJfJa3pMbvvafM7A3m6H5wWE+xMoAJM+tVZOTk+H53FvJLwQ+WmDb6X0lAER0cX39Y5wzXZwBFBXmAjDbFq0Jw/Ci6MBl2TvrgMs5WfrabjdfG2MqE7zEmWkGbm+3xuvMdRdhWWVLAZClK/LoQxgOL7M6/Nt6iSkkKdN80HwzGo0qG7yQRY+179qpLgFew/ZIUnHzNFlvSyt0Ugo1peLlGWkdugy1K34VrBwdnrrGSEwhl/K/kMlJNTBBl2EfEnDvF7PyACLSZPsOTLAbAzLdGAAuIAz7KGkNRPqVfUYFdeNmIM6oAjjzJVLceM39KfAz9b/cY3BXgfbLvk4vAm7hKr7wrWCROGrbmoGagZqBmoHqM/ALRqXtUMTD0JUAAAAASUVORK5CYII="
}), /*#__PURE__*/React.createElement("image", {
  id: "image4",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACeElEQVRoBe1X0W3bMBDlURrAI6QbsKb8b03QZIIkE7SZoM0ETSaIu4E7Qd1vm4I2qDdoBjB9xRNEwWGlJAotGQFIwKApknf3no6PJyFiiwxEBiIDkYHIQGQgMhAZeLcMUFfks9lMMfMlM8+FEMpbt2Lmn/v9flGW5aM3N+rwPwBKqbMkSR6EEAj8pfZIRPe73e7uVECeANBanwshEPzkpci9+dJam58CRANgOp1eERGCf2vbWms/jg1CIlqkDRF9f2vk9T6k3q9AG723VwDqnG9Lm5UQYtvDqsKb7LE+eCllWTZnZp+5pbX2GumQZdk3Zv7awxNUqeyxvvdSZv5RFMUCG1NIpWdhYYy59p71GeJNvkbB+th8spaI5lrrS2NMnnrOtoHBO0dDvwUQNEd2AMCZ88rM9+5/YA8i8kAbndu11n8h9cz8GQCaJqU8Vu4qrTU3hof7M6lUaDj7w1v2AXwa3mWQh0NJRxmTA0CTNsx8pZRquw+CvLZsxv1ycfC8ZGYon4sFfSWTbg0z3xhjPqAXQqyklPlms1lJIoIx1yZJkoTeyM5WZ09Et8aYJQJB0KijoOvoMYe+VkPMV0wXRXEHg+ghEOv1ugJLdfX5x/NWEtENEA5wkR1LqquQq2JOa40irq0EgJ7j10itB7RteFGz2zZ39GfVIbbWIq8QqN9wHvoEvxwzeARbAUDNg0PRAcIH1TVGLoeUIF12n33eyCgORQ3iUKqe3XwwieLvtB80LhjIaJqmX3BNv+LLbMvMt64ydDbG7JsvMt8pgEgpz4kIlxvOAj7s8XYga9Dt32Pnux9jHEcGIgORgchAZCAyEBmIDLxzBv4BTTf6OIYYOBIAAAAASUVORK5CYII="
}), /*#__PURE__*/React.createElement("image", {
  id: "image5",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACRklEQVRoBe1Wu24TQRQ9d20cKRIUiKT1bnBHGSoskRkjOY8KpASKdHxCviA/QE+VLgUKNUhGxm5sKihA6RLtukxAaaIUmCiDNhT2Jh7PYye2gLG00sy95z7OHe+cBfzv350A8aUnr9IHAN0UzRtJvPFgo/Rj7mQHEJt/Gqfde9/vvtzb3+u7JuKcQLVavV0qzrwFoZ5pVqDRP/+53ul0TjP2nBunBOqP6vO/SufvACxK+vp8q19ca3QbxxK/sdkZAcZYhRC8B1BRdHEgcLHabrcPFDgtd6CFUoA454skgo5G82mmSopNYxRptdy5CdQe1+oQ1AJhXqtiCkqxglqXsdpBo4GF0WY9K2NsE6A3IMzqRWRQMwBehFE5TpLkW8ZjsLEmwJf4FlHwGoSiQb0slFAg0LOoHJ4mveRT1qm3syFwKVAgbDsSKALRclReuJP04g96bQ9QRrfQdYEaJHKzMhc8bQJSgXLT+SCLoeBpEdAQqEEDLlYCX4IirTWbzSNVOiUBA4FS1TL1HwpcrKgEb6wOGAqUaYMq/H1C0GWMPRwHlBKwEqhxlex8c4SgxTlfloWPvEZzCpSslq29BEHPF8KoF/fir1eTXCPgRKCuVsm7JxRAeBqG0VmSxN3hdMqXeBg8vOasJob3edet9kerXqTvQN6GJhXvCUxq0rI6/gRkk5mU3Z/ApCYtq+NPQDYZb/9fJmD1/ZEOx38LOfqL+FvI0SCt0/gTsB6do0B/Ao4G6dP8tRPwSjzto/O30LRPwNef9gR+A+YtkFwFpJQrAAAAAElFTkSuQmCC"
}), /*#__PURE__*/React.createElement("image", {
  id: "image6",
  width: "48",
  height: "48",
  preserveAspectRatio: "none",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE+UlEQVRoBe1YPUxbVxg95xpQJC90cdeEpUuQOjIlz1CxEYWtTG0kdvZ2KBmatXhHKp0Yk2ZExbxsTGmkMCdZ66UsHmrs+1Xnvncb1/zZvi+lA5bM/f9+z7nfNUTFnwcPvlqs0TaNdo/kMeBPzLhJ4/uB1Xbu3EHn4OCgW5VaV5UgyWk2m4+c8z+S1iCtRbPFYDxtV+vO9Vv9v/qPqtTJKoStrq7We73BJg0Linwhk4eArTiga+RbOaN5M3bg8MfsbK1VRSaqykBdxsp47933JE80BnhotF0zWzJYd2ZuZkt7NAZQryJ4yRlQ9M96Zy2C9RBd+rqBDTlhZvcvzIAsp6/Pzs1+d3Bw0ElxJDkDvV5vUQYLJnD+MBgP6wwG3JdhPkQ6ELmjvhHvwhdsnJ2dKRNJn2QHSEV7hLDmuiKzIBRgZNxUxAWvAlq2UvSRfBvNJLkfkMC6J+8ZrB7gAnc/3EIir2FB8kl0Pdio1WyDVhhN9T3fpupPzkBhwBWEpd0TeQnriBMwvNQ39FOtB5CcgcKG4sqkcQnkMQ2L/V6/peKl9dAHlYpjD9vQnIqc0SdDKDkD5qxD+hPB5zLCBvLq/oc/iUGnNzl38w7Qs2HGrVCswp1/CWF1vYrM4KGi7wlxoBEdmratBELCt2Bj5j4nfUdX6ShhzdgIJDcsENZgBdGX05VASAVJwlRlB77WikVsmLBysu/ds1CtgXqoys6Siph0JmdAMOj1+ruBsMS78JgzdGnYF0ykRJBRhoq1IWIbX2o95ZOcgXGUl4QNW2MlLgg/zumr9yQ7YM66c3MzmypeqrKqsEa+DyQlj12ZCT3mRiuxbrCrzbt+tQoI6TH3jCAEo5obbImwkdggFkMRu4DY/5tKPPqY020jMgsm+l5G7Ovje/2O5AwIQs5zv6iwXCoeb1iIhBXmLyK2oKWz15t49Y5kDoyKJ1Ev+DC68mnGyQ7Q6zWKDV2VIarFry1cRmzticTW2VS3JoZQM1u2QqnlR/lRE8QXBNZgtmZ6r6mgATjr9b/WPo1rzq9pMqwRa3EexGv1m1nzCGCm/lHenuhXYnIGpPQmP7cO3GT0pfs2A7cZSIzAFBCyvNBZXHserhxPbokHPpSy7panTyeVMrEDBEulQJatPM7z3+TAxIoLQ/2LLMu+BFA6YG8+uQMeeBWVEH5LfQKtODdua8BOnuenDi7IKOTw13HPx30TVb14qJkt/wlgXmODayoLw9U07ru85RvDoKnIE+73uM/gP5NTcTxOOzGEJHQ44oR/nmXZvMHWCby4XqnlpfEgaj/H/TEjcTxuO5UD7by9DTDidZ6oHSma7by9buA6EIk+bIaijifh/RSCoDMm/OvzAfBPy/5EzVQQkgaRj3AyPEBJRCbwtJ23d6IFBUFn5kuih+ksW/6WwE/D5wy+med5DEg8PlY7tQOSfoETmj41YA/gK4Alnm0esIcEHn+8cYJ9pynGS0KSA6UT8wSfx+dwMGusP+KCPcnz/J9reaxjI5uSHYjyVBOKa7UocHH+fCsuWCvP23vn1yafqcyBqDrLsruAywj75mNWFG3+Avg8NeJRT2wrdyAKXs6Wtw34QeOS3Ntxrcp2qmu0SgNSZd06kBrB1PPJHBDWLzLCYA+HScxQF87v9PB7KcSe+N8qoyZEoo7O/7vEMDMg/Nvk/L4ZPcenrgW3HDgf0f925m+Kpp5YxYWwhQAAAABJRU5ErkJggg=="
}), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  filterUnits: "userSpaceOnUse",
  x: "-49",
  y: "-80",
  width: "699",
  height: "494",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  filterUnits: "userSpaceOnUse",
  x: "257",
  y: "296",
  width: "172",
  height: "64",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  filterUnits: "userSpaceOnUse",
  x: "435",
  y: "296",
  width: "168",
  height: "64",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d",
  filterUnits: "userSpaceOnUse",
  x: "-103",
  y: "-190",
  width: "808",
  height: "128",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 255 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: "0",
  y1: "0",
  x2: "1",
  y2: "0",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 553.002 -800 0 800 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#BFBFBF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#DFDFDF",
  stopOpacity: ".28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".94",
  stopColor: "#FFF"
}))));